module.exports = __webpack_public_path__ + "img/nighticon.8a71febe.svg";